import https from "./https";
import store from "@/store";

const apiLog = {
  getApiLogs(params) {
    const organization = store.state.general.organization;
    const searchParams = new URLSearchParams(params);

    return https.get(
      `/admin/organizations/${organization.id}/api-logs?${searchParams}`
    );
  },
};

export default apiLog;
